import { useRef } from 'react';
import DOMPurify from 'dompurify';
import LuckyNumberStyles from './LuckyNumberStyles';
import LuckyNumberPageMenu from './LuckyNumberPageSection/menuBar';
import styled from 'styled-components';
import LuckyNumberAgreementModal from './LuckyNumberAgreementModal';
import LuckyNumberListModal from './LuckyNumberListModal';
import LuckyNumberPageSection from './LuckyNumberPageSection';
import Breakpoints from '../config/Breakpoints';
import LuckyNumberConfetti from '../atom/LuckyNumberConfetti';

const LuckyNumberPageContent = ({pageData, reload}) => {
    const agreementModalRef = useRef();
    const luckyNumberModalRef = useRef();

    const openAgreementModal = () => {
        if(pageData.agreement?.urlDocument) {
            agreementModalRef.current.openAgreement();
        }
    }

    const openAgreementAcceptModal = () => {
        if(pageData.agreement?.urlDocument) {
            agreementModalRef.current.openAgreementAccept();
        }
    }

    const openLuckyNumberModal = () => {
        luckyNumberModalRef.current.openDialog();
    }

    const LuckyNumberPageContainer = styled.div`
        flex: 1;
        display: flex;
        flex-direction: column;
        max-width: calc(100vw - 3rem);
        gap: 4rem;

        @media ${Breakpoints.md} {
            max-width: calc(100vw - 6rem);
        }

        @media screen and (min-width: 1536px) {
            max-width: 90rem;
        }

        ${LuckyNumberStyles}
        ${pageData.pageConfig?.customCss && pageData.pageConfig.customCss}
    `;

    return (
        <LuckyNumberPageContainer className="luckyNumber__container">
            <LuckyNumberPageMenu 
                promoData={pageData} 
                openAgreement={openAgreementModal} 
                openAcceptAgreement={openAgreementAcceptModal}
                openLuckyNumbers={openLuckyNumberModal}

            />
            {
                pageData.pageConfig.sections && 
                pageData.pageConfig.sections.length > 0 && 
                pageData.pageConfig.sections.map((section, index) => (
                    <LuckyNumberPageSection 
                        sectionData={section} 
                        promoData={pageData} 
                        order={index > 0 ? index+2 : index+1} 
                        openAgreement={openAgreementModal} 
                        openAcceptAgreement={openAgreementAcceptModal}
                        openLuckyNumbers={openLuckyNumberModal}
                        key={`menubar_${section.id}`} 
                    />
                ))
            }
            {pageData.pageConfig.footnotes && <div style={{order: pageData.pageConfig.sections.length + 1}} className='luckyNumber__footnotes' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(pageData.pageConfig.footnotes)}} />}

            {pageData.agreement?.urlDocument && (
                <LuckyNumberAgreementModal 
                    ref={agreementModalRef}
                    promoId={pageData.id}
                    agreementData={pageData.agreement} 
                    reload={reload}
                    style={{order: '9999'}}
                />
            )}

            <LuckyNumberListModal 
                ref={luckyNumberModalRef}
                promoData={pageData}
                style={{order: '9999'}}
            />

            <LuckyNumberConfetti promoId={pageData.id} show={pageData.memberHasWinnerNumber && !pageData.isEnded} />
        </LuckyNumberPageContainer>
    )
};

export default LuckyNumberPageContent;